import styled from "@emotion/styled";
import { Typography, Box, Stack } from "@mui/material";


const BannerImage = styled('img')(({ src }) => ({
    src: `url( ${src} )`,
    width: "100%",
    height: "100%",
    opacity: "0.5",
    objectFit: "cover"
}));



const BannerItem = (props) => {

    return (
        <Box sx={{
            height: `${props.size}px`,
            position: "relative" }}>
            <BannerImage src={props.item?.image}/>
            <Box sx={{
                position: "absolute",
                top: "0",
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                left: "3%" }}>

                <Stack sx={{
                    width: { xs: "100%", sm: "60%"} ,
                    height: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center" }}>

                        <Typography sx={{ 
                            textShadow: "0px 0px 2px white",
                            fontSize: { xs: "30px", sm: "32px" }}} 
                            fontWeight="bold" 
                            align="left">

                            {props.item?.header}
                        </Typography>

                        <Typography sx={{
                            fontSize: { xs: "22px", sm: "26px" }}}
                            align="left">

                            {props.item?.text}
                        </Typography>

                </Stack>
            </Box>
                
        </Box>

    );
}

export default BannerItem